import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import DashboardLayout from '../layouts/DashboardLayout';

// Component to protect routes that require authentication
const PrivateRoute = ({ requiredPermission }) => {
  const { currentUser, hasPermission } = useAuth();
  
  console.log('PrivateRoute: Checking authentication', { currentUser, requiredPermission });
  
  // If user is not logged in, redirect to login page
  if (!currentUser) {
    console.log('PrivateRoute: No current user, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  // If a specific permission is required and user doesn't have it, redirect to dashboard
  if (requiredPermission && !hasPermission(requiredPermission)) {
    console.log('PrivateRoute: User lacks required permission, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }
  
  console.log('PrivateRoute: User authenticated, rendering protected route');
  // If user is authenticated and has required permission, render the route with dashboard layout
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default PrivateRoute;
